import { render, staticRenderFns } from "./AdminOrgLeader.vue?vue&type=template&id=78e8bf0e&scoped=true&"
import script from "./AdminOrgLeader.vue?vue&type=script&lang=js&"
export * from "./AdminOrgLeader.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrgLeader.vue?vue&type=style&index=0&id=78e8bf0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e8bf0e",
  null
  
)

export default component.exports